import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";


export default function ApplicationUsageBarGraph({applicationUsageBarGraph}) {
  return (
   <div className="bg-white shadow rounded-xl p-5 border">
     
      <ResponsiveContainer width="100%" height={380}>
        <BarChart data={applicationUsageBarGraph}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" />
          <YAxis
            label={{
              value: "Hours Used",
              angle: -90,
              position: "insideLeft",
              style: { textAnchor: "middle" },
            }}
          />
          <Tooltip />
          <Legend
            verticalAlign="bottom"
            align="center"
            wrapperStyle={{ paddingTop: "20px" }}
          />
          <Bar dataKey="usageHours" fill="#1d4ed8" name="Usage hours" />
          <Bar dataKey="lastWeek" fill="#f59e0b" name="Last Week" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
